// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// import Modal, { ModalPresentationProps } from "@insite/mobius/Modal"; // Starter Custom Code
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
// import FormActions from "@store/Library/Components/Toolkit/FormActions"; // Store Custom Code
import Modal, { ModalPresentationProps, ModalProps } from "@store/MobiusOverrides/Modal/Modal";
import expandProps from "@toolkit/Framework/Common/Utilities/expandProps";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import FormActions, { FormActionsProps } from "@store/Library/Components/Toolkit/FormActions";
/* Store Custom Code - End */

interface OwnProps {
    modalIsOpen: boolean;
    headlineText: React.ReactNode;
    messageText: React.ReactNode;
    cancelButtonText: string;
    submitButtonText: string;
    extendedStyles?: TwoButtonModalStyles;
    onCancel: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onSubmit: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onClose?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    cancelTestSelector?: string;
    submitTestSelector?: string;
    dataTestSelector?: string;
    // Starter Custom Code
    overridedStyles?: TwoButtonModalStyles;
    setOverlayScrimRef?: (ref: React.Ref<HTMLDivElement>) => void;
    // Store Custom Code
    isCloseable?: ModalProps["isCloseable"];
    hideTitle?: boolean;
}

type Props = OwnProps;

export interface TwoButtonModalStyles {
    modal?: ModalPresentationProps;
    container?: GridContainerProps;
    textGridItem?: GridItemProps;
    messageText?: TypographyProps;
    buttonsGridItem?: GridItemProps;
    submitButton?: ButtonPresentationProps;
    cancelButton?: ButtonPresentationProps;
    // Store Custom Code
    formActions?: FormActionsProps;
}

export const twoButtonModalStyles: TwoButtonModalStyles = {
    modal: {
        sizeVariant: "small",
    },
    cancelButton: {
        variant: "tertiary", // Store Custom Code
    },
    /* Store Custom Code - Start */
    messageText: {
        forwardAs: "div",
    },
    /* Store Custom Code - End */
};

class TwoButtonModal extends React.Component<Props> {
    private readonly styles: TwoButtonModalStyles;

    constructor(props: Props) {
        super(props);

        this.styles = expandProps(twoButtonModalStyles, props.extendedStyles, props.overridedStyles); // Starter Custom Code
    }

    formCancelHandler = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.preventDefault();
        this.props.onCancel(e);
    };

    formSubmitHandler = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.preventDefault();
        this.props.onSubmit(e);
    };

    formCloseHandler = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.preventDefault();
        if (this.props.onClose) {
            this.props.onClose(e);
        } else {
            this.props.onCancel(e);
        }
    };

    render() {
        const styles = this.styles;
        const { isCloseable, hideTitle, headlineText } = this.props;

        return (
            <Modal
                headline={hideTitle ? undefined : headlineText} /* Store Custom Code */
                {...styles.modal}
                isOpen={this.props.modalIsOpen}
                data-test-selector={this.props.dataTestSelector}
                handleClose={this.formCloseHandler}
                isCloseable={isCloseable} /* Store Custom Code */
                hideTitle={hideTitle} /* Store Custom Code */
                // Starter Custom Code
                setOverlayScrimRef={this.props.setOverlayScrimRef}
            >
                {/* Starter Custom Code - Start */}
                <Typography {...styles.messageText} data-test-selector="twoButtonModal_MessageContent">
                    {this.props.messageText}
                </Typography>
                <FormActions {...styles.formActions}>
                    <Button
                        {...styles.submitButton}
                        onClick={this.formSubmitHandler}
                        data-test-selector={this.props.submitTestSelector}
                    >
                        {this.props.submitButtonText}
                    </Button>
                    <Button
                        {...styles.cancelButton}
                        onClick={this.formCancelHandler}
                        data-test-selector={this.props.cancelTestSelector}
                    >
                        {this.props.cancelButtonText}
                    </Button>
                </FormActions>
                {/* Starter Custom Code - End */}
            </Modal>
        );
    }
}

export default TwoButtonModal;
